import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useState, useEffect } from 'react';
import { List, Button, Input, Label, Header } from 'semantic-ui-react';
import * as API from '../../../../../../../../utils/api';
import { RESULTS_INCREMENT } from './DomainSearchForm.constants';
import { ensureTLD, hasMoreResults } from './DomainSearchForm.utils';
import './DomainSearchForm.css';
var defaultProps = {};
export function DomainSearchForm(_ref) {
  var domainName = _ref.domainName,
      onChangeDomainType = _ref.onChangeDomainType,
      onSelect = _ref.onSelect;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = useState(domainName),
      _useState4 = _slicedToArray(_useState3, 2),
      domainSearchInput = _useState4[0],
      setDomainSearchInput = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      domainResults = _useState6[0],
      setDomainResults = _useState6[1];

  var _useState7 = useState(RESULTS_INCREMENT),
      _useState8 = _slicedToArray(_useState7, 2),
      numShowResults = _useState8[0],
      setNumShowResults = _useState8[1];

  function searchDomains() {
    return _searchDomains.apply(this, arguments);
  }

  function _searchDomains() {
    _searchDomains = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var finalDomain, _yield$API$searchDoma, results;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              finalDomain = ensureTLD(domainSearchInput);
              _context.prev = 1;
              setLoading(true);
              _context.next = 5;
              return API.searchDomains(finalDomain);

            case 5:
              _yield$API$searchDoma = _context.sent;
              results = _yield$API$searchDoma.data;
              setDomainResults(results);

            case 8:
              _context.prev = 8;
              setLoading(false);
              return _context.finish(8);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1,, 8, 11]]);
    }));
    return _searchDomains.apply(this, arguments);
  }

  function onDomainSearchInputChange(e, _ref2) {
    var value = _ref2.value;
    setDomainSearchInput(value);
  }

  function onShowMoreResults() {
    var nextNumShowResults = domainResults.length > numShowResults + RESULTS_INCREMENT ? numShowResults + RESULTS_INCREMENT : domainResults.length;
    setNumShowResults(nextNumShowResults);
  }

  function onSelectInternal(_ref3) {
    var selectedDomainName = _ref3.DomainName;
    return onSelect(selectedDomainName);
  }

  useEffect(searchDomains, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Header, {
    as: "h2",
    className: "day-smart-domain-select-header"
  }, "Select A Domain"), /*#__PURE__*/React.createElement(Input, {
    className: "domain-search-input",
    type: "text",
    placeholder: "mydomain.com",
    labelPosition: "left",
    value: domainSearchInput,
    onChange: onDomainSearchInputChange
  }, /*#__PURE__*/React.createElement(Label, {
    className: "https-label domain-search-input-consistent-padding"
  }, "https://"), /*#__PURE__*/React.createElement("input", {
    className: "borderless-input domain-search-input-consistent-padding",
    value: domainSearchInput
  }), /*#__PURE__*/React.createElement(Button, {
    className: "domain-search-button",
    type: "submit",
    onClick: searchDomains,
    loading: loading
  }, "Search")), /*#__PURE__*/React.createElement(Button, {
    id: "custom-domain-connect-button",
    className: "publish-now-from-request-button extra-margin centered-content blue-color",
    onClick: onChangeDomainType
  }, "I already own a domain to connect"), domainResults.length > 0 && /*#__PURE__*/React.createElement("h3", {
    className: "header-text blue-color domain-search-header"
  }, "Suggested results:"), /*#__PURE__*/React.createElement(List, {
    className: "domain-results",
    divided: true,
    verticalAlign: "middle"
  }, domainResults.slice(0, numShowResults).map(function (result, index) {
    return /*#__PURE__*/React.createElement(List.Item, {
      className: "domain-search-result".concat(result.Availability !== 'AVAILABLE' ? ' domain-unavailable' : ''),
      key: result.DomainName,
      onClick: function onClick() {
        return onSelectInternal(domainResults[index]);
      }
    }, /*#__PURE__*/React.createElement(List.Content, {
      className: "domain-search-result-label"
    }, result.DomainName), result.Availability === 'AVAILABLE' ? /*#__PURE__*/React.createElement(List.Content, null, /*#__PURE__*/React.createElement("p", {
      className: "green-color domain-search-free-label"
    }, "FREE")) : /*#__PURE__*/React.createElement(List.Content, null, /*#__PURE__*/React.createElement("p", {
      className: "red-color domain-search-free-label"
    }, "Unavailable")));
  })), hasMoreResults(domainResults.length, numShowResults) && /*#__PURE__*/React.createElement(Button, {
    onClick: onShowMoreResults,
    className: "centered-button more-results-button"
  }, "Load more results"));
}
DomainSearchForm.defaultProps = defaultProps;
export default DomainSearchForm;